import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { createPassword, validateUser } from '../../services/oauth';
import { successNotification, dangerNotification, warningNotification } from '../../services/notification';
import Loader from '../../components/Loader';
import CreatePasswordForm from './CreatePasswordForm';

export type CreatePasswordProps = {
  initialPassword?: string;
  initialPasswordRepeat?: string;
};

const CreatePass = (props: CreatePasswordProps) => {
  const history = useHistory();
  const [isValidating, setIsValidating] = useState(true);
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [userId, setUserId] = useState('');
  const { search } = useLocation();
  const splits = search.split('&');
  const token = splits[0].replace('?token=', '');

  useEffect(() => {
    validateUser(token)
      .then((response) => {
        console.log('RESPOSTA', response);
        setUserId(response.id)
      })
      .catch((e) => {
        console.log('ERROR', e);
        dangerNotification('Oops', 'Ocorreu algum erro na autenticação.');
        history.push('/');
      })
      .finally(() => {
        setIsValidating(false);
      });
  }, [history, token]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (password !== passwordRepeat) {
      warningNotification('Oops...', 'As senhas não são compatíveis');
      return;
    }

    if (userId) {
      try {
        const response = await createPassword(password, userId);
        console.log('RESPOSTA', response);
        successNotification('Sucesso!', 'Um link para redefinição da senha foi enviado para o e-mail informado');
      } catch (error) {
        console.log('ERRO', error);
        dangerNotification('Oops...', 'Ocorreu algum erro com a solicitação. Por favor, tente novamente mais tarde');
      } finally {
        history.push('/');
      }
    }
  };

  return (
    <>
      {isValidating ? (
        <Loader />
      ) : (
        <CreatePasswordForm
          password={password}
          passwordRepeat={passwordRepeat}
          onPasswordChange={(e) => setPassword(e.target.value)}
          onPasswordRepeatChange={(e) => setPasswordRepeat(e.target.value)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default CreatePass;
